import PropTypes from "prop-types";
import { URL } from "@myloc/myloc-utils";
import { ReactNode } from "react";
import { ValueOf } from "../../../../utils/dataTypes";
import { TARGET } from "../Constants/constants";

const DownloadLink = ({
  url,
  target = TARGET.FULL,
  download,
  children,
  customCssClass,
}: {
  url: URL | string;
  target?: ValueOf<typeof TARGET>;
  download?: string;
  children?: ReactNode;
  customCssClass?: string;
}) => (
  <a href={url instanceof URL ? url.toString : url} download={download} target={target} className={customCssClass}>
    {children}
  </a>
);

DownloadLink.propTypes = {
  url: PropTypes.oneOfType([PropTypes.instanceOf(URL), PropTypes.string]).isRequired,
  target: PropTypes.oneOf(Object.values(TARGET)),
  download: PropTypes.string,
  children: PropTypes.node,
  customCssClass: PropTypes.string,
};

export default DownloadLink;
